module.exports = __webpack_public_path__ + "static/media/Story-Research-Photo 1.83df8132.jpg";